const customInitiativeEntries = (state = INITIAL.customInitiativeEntries || {}, action) => {
  switch (action.type) {
    case 'CREATE_CUSTOM_INITIATIVE_ENTRY':
      return { ...state, [action.model.id]: action.model }
    case 'UPDATE_CUSTOM_INITIATIVE_ENTRY':
      return { ...state, [action.model.id]: { ...state[action.model.id], ...action.model } }
    case 'DESTROY_CUSTOM_INITIATIVE_ENTRY':
      const newState = { ...state }
      delete newState[action.model.id]
      return newState
    default:
      return state
  }
}

export default customInitiativeEntries
